export const accountActions = [
  {
    name: 'showAlertMessage',
    label: 'Show Alert Message',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'successMessage',
        label: 'Success Message',
        type: 'textArea',
        value: '',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'errorMessage',
        label: 'Error Message',
        type: 'textArea',
        value: '',
      },
    ],
    // allowedTypes: ['number'],
  },
  {
    name: 'showConfirmationMessage',
    label: 'Show Confirmation Message',
    args: [
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      {
        name: 'confirmBtnText',
        label: 'Confirm Button Text',
        type: 'text',
        value: '',
      },
      {
        name: 'cancelBtnText',
        label: 'Cancel Button Text',
        type: 'text',
        value: '',
      },
      {
        name: 'destinationAfterCancel',
        label: 'Page On Cancel',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
    ],
  },
];
